export function getAccessDeniedMessage() {
  return 'This test environment is invite-only. Your email is not on the access list.';
}

export const ACCESS_DENIED_STORAGE_KEY = 'accessDeniedMessage';

export function storeAccessDeniedMessage(message = getAccessDeniedMessage()) {
  try {
    sessionStorage.setItem(ACCESS_DENIED_STORAGE_KEY, message);
  } catch {
    // ignore storage errors
  }
}

export function consumeAccessDeniedMessage() {
  try {
    const message = sessionStorage.getItem(ACCESS_DENIED_STORAGE_KEY);
    if (message) {
      sessionStorage.removeItem(ACCESS_DENIED_STORAGE_KEY);
    }
    return message;
  } catch {
    return null;
  }
}
